const initialState = {
  featured: [],
  sale: [],
  trending: [],
  newArrivals: [],
  loading: false,
  error: null,
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case "PRODUCT_LOADING":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "FEATURED_PRODUCTS_SUCCESS":
      return {
        ...state,
        featured: action.payload || [],
        loading: false,
      };

    case "SALE_PRODUCTS_SUCCESS":
      return {
        ...state,
        sale: action.payload || [],
        loading: false,
      };

    case "TRENDING_PRODUCTS_SUCCESS":
      return {
        ...state,
        trending: action.payload || [],
        loading: false,
      };

    case "NEW_PRODUCTS_SUCCESS":
      return {
        ...state,
        newArrivals: action.payload || [],
        loading: false,
      };

    case "PRODUCT_ERROR":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default productReducer;